import { getColor } from 'helpers';
import { styled } from 'libs/ui/styled';
import { ColorsDark, ColorsLight } from 'libs/ui/theme';

import { LayoutClasses } from './types';

export interface LayoutStyledProps {
  /**
   * filled - fills in the background color except for mobile
   */
  backgroundVariant?: 'filled' | 'outlined';
}

export const LayoutStyled = styled('div')<LayoutStyledProps>(
  ({ backgroundVariant = 'filled', theme }) => ({
    ...(backgroundVariant === 'filled' && {
      [theme.breakpoints.up('mobile')]: {
        backgroundColor: theme.palette.background.default,
      },
      [theme.breakpoints.down('mobile')]: {
        backgroundColor: getColor(theme, {
          dark: ColorsDark.black,
          light: ColorsLight.white,
        }),
      },
    }),

    ...(backgroundVariant === 'outlined' && {
      backgroundColor: getColor(theme, {
        dark: ColorsDark.black,
        light: ColorsLight.white,
      }),
    }),

    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',

    [LayoutClasses.content.css]: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },

    [LayoutClasses.footer.css]: {
      height: 72,
    },
  })
);
